export function scrollToTop() {
  document.documentElement.scrollTo({
    behavior: 'smooth',
    top: 0,
  });
}
